import React, { useContext } from "react";
import "./Landing.css";
import { Context } from "../../context/Context";
import { Hero } from "../../components/landing/Hero/Hero";
import { WhatsAppFloat } from "../../components/landing/WhatsAppFloat/WhatsAppFloat";

export const Landing = () => {
  const { lang } = useContext(Context);

  return (
    <div className={`landing-page ${lang === "ar" ? "ar" : "en"}`}>
      <Hero />
      <WhatsAppFloat />
    </div>
  );
};

export default Landing;
